// Small helpers with no opinion about the game.
export const clamp=(v:number,a:number,b:number)=>Math.max(a,Math.min(b,v));
export const rnd=(a:number,b:number)=>a+Math.random()*(b-a);
export const pick=<T>(l:readonly T[])=>l[(Math.random()*l.length)|0];
export const BEAT=(t:number)=>0.5-0.5*Math.cos(t*0.009);
export const backOut=(g:number)=>1+2.70158*Math.pow(g-1,3)+1.70158*Math.pow(g-1,2);
export const smooth=(k:number)=>k*k*(3-2*k);   // eased at both ends, for k from 0 to 1
// An angle brought into -π..π: how far round the short way is, and which way.
export const wrap=(a:number)=>Math.atan2(Math.sin(a),Math.cos(a));
// A heading eased toward another by the shortest arc, `k` of the way (k is a
// rate times dt, and never overshoots past 1). How everyone in the field turns.
export const turnToward=(from:number,to:number,k:number)=>from+wrap(to-from)*Math.min(1,k);
export const $=<T extends HTMLElement=HTMLElement>(id:string)=>document.getElementById(id) as T;
// restart a CSS animation: the class comes off, the layout is forced, the class goes back on
export const restart=(el:HTMLElement,cls:string)=>{el.classList.remove(cls);void el.offsetWidth;el.classList.add(cls);};
